// Automatic food name translations — EN as base, mapped to all supported languages
// Covers the most common ~120 food items. Falls back to English if no translation found.

const enToLang = {
  // === Fruits ===
  "apple":        { bg: "Ябълка", es: "Manzana", de: "Apfel", ar: "تفاحة", zh: "苹果" },
  "banana":       { bg: "Банан", es: "Platano", de: "Banane", ar: "موز", zh: "香蕉" },
  "orange":       { bg: "Портокал", es: "Naranja", de: "Orange", ar: "برتقال", zh: "橙子" },
  "grape":        { bg: "Грозде", es: "Uva", de: "Traube", ar: "عنب", zh: "葡萄" },
  "strawberry":   { bg: "Ягода", es: "Fresa", de: "Erdbeere", ar: "فراولة", zh: "草莓" },
  "watermelon":   { bg: "Диня", es: "Sandia", de: "Wassermelone", ar: "بطيخ", zh: "西瓜" },
  "pear":         { bg: "Круша", es: "Pera", de: "Birne", ar: "كمثرى", zh: "梨" },
  "peach":        { bg: "Праскова", es: "Melocoton", de: "Pfirsich", ar: "خوخ", zh: "桃子" },
  "cherry":       { bg: "Череша", es: "Cereza", de: "Kirsche", ar: "كرز", zh: "樱桃" },
  "lemon":        { bg: "Лимон", es: "Limon", de: "Zitrone", ar: "ليمون", zh: "柠檬" },
  "pineapple":    { bg: "Ананас", es: "Pina", de: "Ananas", ar: "اناناس", zh: "菠萝" },
  "mango":        { bg: "Манго", es: "Mango", de: "Mango", ar: "مانجو", zh: "芒果" },
  "kiwi":         { bg: "Киви", es: "Kiwi", de: "Kiwi", ar: "كيوي", zh: "猕猴桃" },
  "avocado":      { bg: "Авокадо", es: "Aguacate", de: "Avocado", ar: "افوكادو", zh: "牛油果" },
  "blueberry":    { bg: "Боровинка", es: "Arandano", de: "Blaubeere", ar: "توت ازرق", zh: "蓝莓" },
  "raspberry":    { bg: "Малина", es: "Frambuesa", de: "Himbeere", ar: "توت العليق", zh: "覆盆子" },

  // === Vegetables ===
  "tomato":       { bg: "Домат", es: "Tomate", de: "Tomate", ar: "طماطم", zh: "番茄" },
  "cucumber":     { bg: "Краставица", es: "Pepino", de: "Gurke", ar: "خيار", zh: "黄瓜" },
  "carrot":       { bg: "Морков", es: "Zanahoria", de: "Karotte", ar: "جزر", zh: "胡萝卜" },
  "potato":       { bg: "Картоф", es: "Patata", de: "Kartoffel", ar: "بطاطس", zh: "土豆" },
  "onion":        { bg: "Лук", es: "Cebolla", de: "Zwiebel", ar: "بصل", zh: "洋葱" },
  "garlic":       { bg: "Чесън", es: "Ajo", de: "Knoblauch", ar: "ثوم", zh: "大蒜" },
  "broccoli":     { bg: "Броколи", es: "Brocoli", de: "Brokkoli", ar: "بروكلي", zh: "西兰花" },
  "spinach":      { bg: "Спанак", es: "Espinaca", de: "Spinat", ar: "سبانخ", zh: "菠菜" },
  "lettuce":      { bg: "Маруля", es: "Lechuga", de: "Salat", ar: "خس", zh: "生菜" },
  "bell pepper":  { bg: "Чушка", es: "Pimiento", de: "Paprika", ar: "فلفل حلو", zh: "甜椒" },
  "eggplant":     { bg: "Патладжан", es: "Berenjena", de: "Aubergine", ar: "باذنجان", zh: "茄子" },
  "zucchini":     { bg: "Тиквичка", es: "Calabacin", de: "Zucchini", ar: "كوسة", zh: "西葫芦" },
  "cauliflower":  { bg: "Карфиол", es: "Coliflor", de: "Blumenkohl", ar: "قرنبيط", zh: "花椰菜" },
  "cabbage":      { bg: "Зеле", es: "Col", de: "Kohl", ar: "ملفوف", zh: "卷心菜" },
  "mushroom":     { bg: "Гъби", es: "Champinon", de: "Pilz", ar: "فطر", zh: "蘑菇" },
  "corn":         { bg: "Царевица", es: "Maiz", de: "Mais", ar: "ذرة", zh: "玉米" },
  "peas":         { bg: "Грах", es: "Guisante", de: "Erbsen", ar: "بازلاء", zh: "豌豆" },
  "celery":       { bg: "Целина", es: "Apio", de: "Sellerie", ar: "كرفس", zh: "芹菜" },
  "pumpkin":      { bg: "Тиква", es: "Calabaza", de: "Kurbis", ar: "يقطين", zh: "南瓜" },
  "asparagus":    { bg: "Аспержи", es: "Esparragos", de: "Spargel", ar: "هليون", zh: "芦笋" },
  "olive":        { bg: "Маслина", es: "Aceituna", de: "Olive", ar: "زيتون", zh: "橄榄" },

  // === Meat ===
  "chicken":      { bg: "Пилешко", es: "Pollo", de: "Huhn", ar: "دجاج", zh: "鸡肉" },
  "chicken breast":{ bg: "Пилешко филе", es: "Pechuga de pollo", de: "Hahnchenbrust", ar: "صدر دجاج", zh: "鸡胸肉" },
  "beef":         { bg: "Телешко", es: "Carne de res", de: "Rindfleisch", ar: "لحم بقر", zh: "牛肉" },
  "pork":         { bg: "Свинско", es: "Cerdo", de: "Schweinefleisch", ar: "لحم خنزير", zh: "猪肉" },
  "lamb":         { bg: "Агнешко", es: "Cordero", de: "Lamm", ar: "لحم ضان", zh: "羊肉" },
  "turkey":       { bg: "Пуешко", es: "Pavo", de: "Truthahn", ar: "ديك رومي", zh: "火鸡" },
  "duck":         { bg: "Патица", es: "Pato", de: "Ente", ar: "بط", zh: "鸭肉" },
  "ham":          { bg: "Шунка", es: "Jamon", de: "Schinken", ar: "لحم مقدد", zh: "火腿" },
  "bacon":        { bg: "Бекон", es: "Tocino", de: "Speck", ar: "لحم مقدد", zh: "培根" },
  "sausage":      { bg: "Наденица", es: "Salchicha", de: "Wurst", ar: "نقانق", zh: "香肠" },
  "steak":        { bg: "Пържола", es: "Filete", de: "Steak", ar: "ستيك", zh: "牛排" },

  // === Fish ===
  "fish":         { bg: "Риба", es: "Pescado", de: "Fisch", ar: "سمك", zh: "鱼" },
  "salmon":       { bg: "Сьомга", es: "Salmon", de: "Lachs", ar: "سلمون", zh: "三文鱼" },
  "tuna":         { bg: "Тон", es: "Atun", de: "Thunfisch", ar: "تونة", zh: "金枪鱼" },
  "cod":          { bg: "Треска", es: "Bacalao", de: "Kabeljau", ar: "قد", zh: "鳕鱼" },
  "shrimp":       { bg: "Скариди", es: "Camaron", de: "Garnele", ar: "روبيان", zh: "虾" },
  "sardine":      { bg: "Сардина", es: "Sardina", de: "Sardine", ar: "سردين", zh: "沙丁鱼" },
  "mackerel":     { bg: "Скумрия", es: "Caballa", de: "Makrele", ar: "ماكريل", zh: "鲭鱼" },
  "trout":        { bg: "Пъстърва", es: "Trucha", de: "Forelle", ar: "سمك السلمون المرقط", zh: "鳟鱼" },

  // === Dairy ===
  "milk":         { bg: "Мляко", es: "Leche", de: "Milch", ar: "حليب", zh: "牛奶" },
  "yogurt":       { bg: "Кисело мляко", es: "Yogur", de: "Joghurt", ar: "زبادي", zh: "酸奶" },
  "cheese":       { bg: "Сирене", es: "Queso", de: "Kase", ar: "جبنة", zh: "奶酪" },
  "butter":       { bg: "Масло", es: "Mantequilla", de: "Butter", ar: "زبدة", zh: "黄油" },
  "cream":        { bg: "Сметана", es: "Crema", de: "Sahne", ar: "كريمة", zh: "奶油" },
  "egg":          { bg: "Яйце", es: "Huevo", de: "Ei", ar: "بيضة", zh: "鸡蛋" },
  "cottage cheese": { bg: "Извара", es: "Requeson", de: "Huttenkase", ar: "جبنة قريش", zh: "奶酪" },
  "mozzarella":   { bg: "Моцарела", es: "Mozzarella", de: "Mozzarella", ar: "موزاريلا", zh: "马苏里拉" },

  // === Grains ===
  "bread":        { bg: "Хляб", es: "Pan", de: "Brot", ar: "خبز", zh: "面包" },
  "rice":         { bg: "Ориз", es: "Arroz", de: "Reis", ar: "ارز", zh: "米饭" },
  "pasta":        { bg: "Паста", es: "Pasta", de: "Nudeln", ar: "معكرونة", zh: "意面" },
  "oats":         { bg: "Овесени ядки", es: "Avena", de: "Haferflocken", ar: "شوفان", zh: "燕麦" },
  "oatmeal":      { bg: "Овесена каша", es: "Avena", de: "Haferbrei", ar: "شوفان", zh: "燕麦粥" },
  "quinoa":       { bg: "Киноа", es: "Quinoa", de: "Quinoa", ar: "كينوا", zh: "藜麦" },

  // === Legumes ===
  "beans":        { bg: "Боб", es: "Frijoles", de: "Bohnen", ar: "فاصوليا", zh: "豆子" },
  "lentil":       { bg: "Леща", es: "Lenteja", de: "Linsen", ar: "عدس", zh: "扁豆" },
  "chickpeas":    { bg: "Нахут", es: "Garbanzos", de: "Kichererbsen", ar: "حمص", zh: "鹰嘴豆" },

  // === Nuts ===
  "almond":       { bg: "Бадем", es: "Almendra", de: "Mandel", ar: "لوز", zh: "杏仁" },
  "walnut":       { bg: "Орех", es: "Nuez", de: "Walnuss", ar: "جوز", zh: "核桃" },
  "peanut":       { bg: "Фъстък", es: "Cacahuete", de: "Erdnuss", ar: "فول سوداني", zh: "花生" },
  "cashew":       { bg: "Кашу", es: "Anacardo", de: "Cashew", ar: "كاجو", zh: "腰果" },
  "hazelnut":     { bg: "Лешник", es: "Avellana", de: "Haselnuss", ar: "بندق", zh: "榛子" },
  "peanut butter":{ bg: "Фъстъчено масло", es: "Mantequilla de mani", de: "Erdnussbutter", ar: "زبدة الفول السوداني", zh: "花生酱" },

  // === Oils ===
  "olive oil":    { bg: "Зехтин", es: "Aceite de oliva", de: "Olivenol", ar: "زيت زيتون", zh: "橄榄油" },

  // === Sweets ===
  "chocolate":    { bg: "Шоколад", es: "Chocolate", de: "Schokolade", ar: "شوكولاتة", zh: "巧克力" },
  "honey":        { bg: "Мед", es: "Miel", de: "Honig", ar: "عسل", zh: "蜂蜜" },
  "sugar":        { bg: "Захар", es: "Azucar", de: "Zucker", ar: "سكر", zh: "糖" },
  "ice cream":    { bg: "Сладолед", es: "Helado", de: "Eiscreme", ar: "ايس كريم", zh: "冰淇淋" },
  "cake":         { bg: "Торта", es: "Pastel", de: "Kuchen", ar: "كعكة", zh: "蛋糕" },
  "cookie":       { bg: "Бисквита", es: "Galleta", de: "Keks", ar: "بسكويت", zh: "饼干" },

  // === Beverages ===
  "water":        { bg: "Вода", es: "Agua", de: "Wasser", ar: "ماء", zh: "水" },
  "coffee":       { bg: "Кафе", es: "Cafe", de: "Kaffee", ar: "قهوة", zh: "咖啡" },
  "tea":          { bg: "Чай", es: "Te", de: "Tee", ar: "شاي", zh: "茶" },
  "juice":        { bg: "Сок", es: "Jugo", de: "Saft", ar: "عصير", zh: "果汁" },

  // === Prepared ===
  "soup":         { bg: "Супа", es: "Sopa", de: "Suppe", ar: "شوربة", zh: "汤" },
  "pizza":        { bg: "Пица", es: "Pizza", de: "Pizza", ar: "بيتزا", zh: "披萨" },
  "burger":       { bg: "Бургер", es: "Hamburguesa", de: "Burger", ar: "برجر", zh: "汉堡" },
  "sandwich":     { bg: "Сандвич", es: "Sandwich", de: "Sandwich", ar: "ساندويتش", zh: "三明治" },
  "salad":        { bg: "Салата", es: "Ensalada", de: "Salat", ar: "سلطة", zh: "沙拉" },
  "pancake":      { bg: "Палачинка", es: "Panqueque", de: "Pfannkuchen", ar: "فطيرة", zh: "煎饼" },
  "french fries": { bg: "Пържени картофи", es: "Papas fritas", de: "Pommes frites", ar: "بطاطس مقلية", zh: "薯条" },
};

/**
 * Translate an English food name to the target language.
 *
 * Strategy (in order):
 *   1. Direct lowercase match on the whole name.
 *   2. FIRST-WORD anchor match — pull the token before the first comma /
 *      slash / parenthesis, strip trailing `s`/`es` (rough English
 *      plural), and try it. USDA food descriptions are almost always
 *      shaped "PrimaryFood, prep, style, ..." so this correctly picks
 *      "Pears" → "pear" → "Круша" without matching stray "sugar" or
 *      "salt" tokens later in the name.
 *   3. Word-boundary substring pass — longest key first, but the key
 *      must appear as a whole word (`\bkey\b`), not a substring. This
 *      still catches multi-word names like "olive oil".
 *
 * @param {string} name - English food name from USDA
 * @param {string} lang - target language code (bg, es, de, ar, zh)
 * @returns {string} - translated name or original if no match
 */
export function translateFoodName(name, lang) {
  if (!name || lang === "en") return name;
  const lower = name.toLowerCase().trim();

  // 1) Direct match
  if (enToLang[lower]?.[lang]) return enToLang[lower][lang];

  // 2) First-word anchor (defensive plural strip)
  const firstToken = lower.split(/[,(/[]|\s\band\b\s/)[0].trim();
  const candidates = [firstToken];
  if (firstToken.endsWith("ies") && firstToken.length > 4) {
    candidates.push(firstToken.slice(0, -3) + "y");   // berries → berry
  }
  if (firstToken.endsWith("es") && firstToken.length > 3) {
    candidates.push(firstToken.slice(0, -2));         // tomatoes → tomato
  }
  if (firstToken.endsWith("s") && firstToken.length > 3) {
    candidates.push(firstToken.slice(0, -1));         // pears → pear
  }
  for (const c of candidates) {
    if (enToLang[c]?.[lang]) {
      const translated = enToLang[c][lang];
      // Preserve the qualifier part after the first token (e.g. ", dried, ...")
      const rest = name.slice(name.toLowerCase().indexOf(firstToken) + firstToken.length).trim();
      const cleanRest = rest.replace(/^[,\-/]\s*/, "").trim();
      if (cleanRest.length < 3) return translated;
      return `${translated} (${cleanRest})`;
    }
  }

  // 3) Word-boundary substring pass (longest key first)
  const keys = Object.keys(enToLang).sort((a, b) => b.length - a.length);
  for (const key of keys) {
    // \b works for ASCII English keys — keys in this map are all ASCII.
    const re = new RegExp(`\\b${key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`, "i");
    if (re.test(lower) && enToLang[key][lang]) {
      const translated = enToLang[key][lang];
      const rest = lower.replace(re, "").trim();
      if (rest.length < 3) return translated;
      return `${translated} (${rest})`;
    }
  }

  return name; // Fallback to original English
}
